const ProvinceInfo = ({ provinciaInfo }) => {
    if (!provinciaInfo) return null;

    return (
        <div id="cont-name-provincia" className="mt-3">
            <strong id="title-prov">
                Provincia a la que pertenece el municipio:
            </strong>
            <span id="caja-prov" className="ms-2">
                {provinciaInfo.nom_dpto?.toUpperCase()} -{" "}
                {provinciaInfo.nom_provincia?.toUpperCase()} | Código:{" "}
                {provinciaInfo.cod_provincia}
            </span>
        </div>
    );
};

export default ProvinceInfo;
